import loadable from "@loadable/component";
import { isRight } from "fp-ts/lib/Either";
import { inject, observer } from "mobx-react";
import React from "react";
import type { Store } from "../../../../../client/stores";
import { Remote } from "../../../../core/components/remote/Remote.component";
import { LeavingSiteDataResolver } from "../../../../core/decoders/LeavingSite.types";
import { Sites_Lookup_By } from "../../../../core/generated/webapi.g";
import { formatRecursive } from "../../../../core/lib/format";
import { getLocale } from "../../../../core/lib/locale";
import { lookup } from "../../../../core/lib/lookup";
import { getFeedContent } from "../../../../core/services/Sites";

const LeavingSite = loadable(() => import("./LeavingSite.component"));

interface LeavingSiteLoaderProps {
    store?: Store;
}

export const LeavingSiteLoader = inject("store")(
    observer(({ store }: LeavingSiteLoaderProps) => {
        if (!store) {
            return null;
        }
        const { site } = store;
        const cacheKey = `leavingsiteloader-${site.index.slug}`;

        return (
            <Remote
                cacheKey={cacheKey}
                loader={() =>
                    getFeedContent({
                        lookup,
                        type: Sites_Lookup_By.Slug,
                        value: site.index.slug,
                        usage: "USAGE:feed-usecases/Leaving Site Warning",
                        context: { "<locale>": getLocale(site) },
                    })
                }
                showLoading={false}
            >
                {({ data }) => {
                    if (data?.length) {
                        const [item] = data;
                        const resolved = LeavingSiteDataResolver.decode(
                            formatRecursive(item.record, { config: site.sections }),
                        );
                        if (isRight(resolved)) {
                            const content = resolved.right;
                            return <LeavingSite feedData={content} />;
                        }
                    }

                    return null;
                }}
            </Remote>
        );
    }),
);

export default LeavingSiteLoader;
